import { useState, useEffect } from 'react'
import { toastError, toastSuccess } from '../../util/toastUtil'
import { Link as RouterLink, useNavigate } from 'react-router-dom'
import { useCustomAxios } from '../../axiosInstance'
import 'react-responsive-carousel/lib/styles/carousel.min.css' // requires a loader
import { Carousel } from 'react-responsive-carousel'
import { Typography } from '@mui/material'
import parse from 'html-react-parser'
import './login.css'
import Link from '@mui/material/Link'
import Grid from '@mui/material/Grid'
import Box from '@mui/material/Box'
import Container from '@mui/material/Container'
import MuiInput from '../../components/MaterialComponent/MuiInput'
import MuiButton from '../../components/MaterialComponent/MuiButton'
import MuiPasswordInput from '../../components/MaterialComponent/MuiPasswordInput'
import { AUTH_ENDPOINTS } from '../../constants/apiConstants'
import { BASE_ROUTE_ENDPOINTS } from '../../constants/routeConstants'

const myData = [
    {
        announcementId: 1,
        message: 'Welcome to the new TMDSAS Evaluator Portal',
        messageDate: Date.now(),
    },
]

const Login = ({ setUser, setLoadingDataGlobal }) => {
    const axios = useCustomAxios()
    const navigate = useNavigate()

    const [password, setPassword] = useState('')
    const [email, setEmail] = useState('')
    const [loginEmailError, setLoginEmailError] = useState(false)
    const [passwordError, setPasswordError] = useState(false)
    const [displayMessages, setDisplayMessages] = useState([])

    useEffect(() => {
        let isSubscribed = true

        const fetchData1 = async () => {
            const displayMesssageParams = {
                portalTypeId: 1,
                portalId: 4,
            }
            const data = await axios
                .get(AUTH_ENDPOINTS.ANNOUNCEMENTS, {
                    params: displayMesssageParams,
                })
                .then((response) => {
                    return response
                })
                .catch((err) => {
                    toastError(
                        err.response.data
                            ? err.response.data
                            : 'Something went wrong, please refresh the page and try again.'
                    )
                })
            if (isSubscribed) {
                const announcements =
                    data && data.data.length > 0 ? data.data : myData
                setDisplayMessages(announcements)
            }
        }

        fetchData1()
        // make sure to catch any error
        // .catch(console.error);

        return () => (isSubscribed = false)
    }, [])

    function ValidateEmail(mail) {
        if (/^[^@]+@[^@]+\.[^@]+$/.test(mail)) {
            return true
        }
        return false
    }

    const handleMouseDownPassword = (event) => {
        event.preventDefault()
    }

    const handleSubmitLogin = async (e) => {
        e.preventDefault()
        if (!ValidateEmail(email)) {
            setLoginEmailError(true)
            return
        } else {
            setLoginEmailError(false)
        }
        if (password == '') {
            setPasswordError(true)
            return
        } else {
            setPasswordError(false)
        }

        const loginPayload = {
            email: email,
            password: password,
            roleId: 8,
        }

        setLoadingDataGlobal(true)

        await axios
            .post(AUTH_ENDPOINTS.LOGIN, loginPayload)
            .then((response) => {
                //get token from response
                const user = response.data
                //set JWT token to local
                sessionStorage.setItem('user', JSON.stringify(user))

                //set token to axios common header
                // setAuthToken(user.accessToken);

                //redirect user to home page
                if (!user.hasProfile) {
                    navigate(BASE_ROUTE_ENDPOINTS.UPDATEPROFILE, {
                        replace: true,
                    })
                } else {
                    navigate(BASE_ROUTE_ENDPOINTS.DASHBOARD, { replace: true })
                }
            })
            .catch((err) => {
                setEmail('')
                setPassword('')
                toastError(
                    err.response.data
                        ? err.response.data
                        : 'Something went wrong, please try again.'
                )
                setLoadingDataGlobal(false)
                // console.log(err);
            })
    }

    return (
        <>
            <div className="carousel-admin-message-container">
                {displayMessages.length > 0 && (
                    <Carousel
                        showThumbs={false}
                        axis="vertical"
                        className="new-carousel"
                        showIndicators={false}
                        autoPlay={true}
                        interval={3000}
                        infiniteLoop
                        showArrows={false}>
                        {displayMessages?.map((element) => (
                            <div
                                key={element.announcementId}
                                className="carousel-admin-message">
                                {parse(element.message)}
                            </div>
                        ))}
                    </Carousel>
                )}
            </div>
            <Container component="main" maxWidth="xs">
                <Box
                    sx={{
                        marginTop: 8,
                        display: 'flex',
                        flexDirection: 'column',
                        alignItems: 'center',
                    }}>
                    <Typography
                        component="h1"
                        variant="h5"
                        sx={{ fontWeight: 'bold' }}>
                        Login
                    </Typography>
                    <Box
                        component="form"
                        onSubmit={handleSubmitLogin}
                        noValidate
                        sx={{ mt: 1 }}>
                        <MuiInput
                            required
                            id="email"
                            label="Email Address"
                            name="email"
                            autoComplete="email"
                            onChange={(e) => setEmail(e.target.value)}
                            autoFocus
                            error={loginEmailError}
                            value={email}
                            helperText={loginEmailError && 'Email is not valid'}
                        />
                        <MuiPasswordInput
                            name="password"
                            label="Password"
                            value={password}
                            id="password"
                            onChange={(e) => setPassword(e.target.value)}
                            error={passwordError}
                            handleMouseDownPassword={handleMouseDownPassword}
                        />
                        <MuiButton>Login</MuiButton>
                        <Grid container justifyContent="space-between">
                            <Grid item xs={6}>
                                <Link
                                    component={RouterLink}
                                    to={BASE_ROUTE_ENDPOINTS.FORGOTPASSWORD}
                                    variant="body2"
                                    sx={{
                                        fontSize: '1.1rem',
                                        fontWeight: 500,
                                        color: '#0D74AE',
                                    }}>
                                    Forgot password?
                                </Link>
                            </Grid>
                            <Grid item xs={6} textAlign="right">
                                <Link
                                    component={RouterLink}
                                    to={BASE_ROUTE_ENDPOINTS.REGISTER}
                                    variant="body2"
                                    sx={{
                                        fontSize: '1.1rem',
                                        fontWeight: 500,
                                        color: '#0D74AE',
                                    }}>
                                    {"Don't have an account? Register"}
                                </Link>
                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </Container>
        </>
    )
}
export default Login
